export default __webpack_public_path__ + "static/media/data_types.392c41aa.jpg";